import { FaTimes } from "react-icons/fa";
import "./Modal.scss";

function Modal({ isModalOpen, onClose, children }) {
  if (!isModalOpen) return null; // only render when open

  return (
    <div className="pay-modal-container" /*onClick={onClose}*/>
      <div className="pay-modal-content" onClick={(e) => e.stopPropagation()}>
        {isModalOpen === "Forgot" ? (
          <button className="forgot-modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        ) : (
          ""
        )}
        {children}
      </div>
    </div>
  );
}

export default Modal;
